/*
 * Potzillas — B2B registrace
 * Odesila formular do Make.com webhooku pres fetch (FormData = bez preflightu).
 * Make pak posle e-mail se schvalovacim odkazem a po kliknuti zalozi zakaznika.
 * Reveal-on-scroll animace stejne jako ostatni potzillas- stranky.
 */
(function () {
  'use strict';

  // ---- Normalizace telefonu na E.164 ----
  // Vrací { ok: true, value: '+420...' } nebo { ok: false } (nejde určit předvolbu).
  function normalizePhone(raw) {
    if (raw == null) return { ok: true, value: '' };
    var v = String(raw).trim();
    if (v === '') return { ok: true, value: '' };
    var hasPlus = v.charAt(0) === '+';
    var digits = v.replace(/\D/g, ''); // jen číslice
    if (!hasPlus && digits.indexOf('00') === 0) { // 00 prefix -> +
      hasPlus = true;
      digits = digits.slice(2);
    }
    var normalized;
    if (hasPlus) {
      normalized = '+' + digits; // zahraniční / s předvolbou -> nech být
    } else if (digits.length === 9) {
      normalized = '+420' + digits; // bez předvolby a 9 číslic = ČR
    } else {
      return { ok: false }; // nelze spolehlivě určit
    }
    if (/^\+[1-9]\d{7,14}$/.test(normalized)) {
      return { ok: true, value: normalized };
    }
    return { ok: false };
  }

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v == null ? '' : v).trim());
  }

  // ---- Chyby u jednotlivých polí ----
  function fieldWrap(input) {
    // U checkboxu souhlasu není .pb-field — chybu pověsíme na celý blok,
    // ne dovnitř flex labelu, kde by se zalomila vedle zaškrtávátka.
    return input.closest('.pb-field') || input.closest('.pb-b2b-terms') || input.parentNode;
  }
  function showFieldError(input, message) {
    var wrap = fieldWrap(input);
    var err = wrap.querySelector('.pb-field__error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'pb-field__error';
      err.setAttribute('role', 'alert');
      wrap.appendChild(err);
    }
    err.textContent = message;
    input.setAttribute('aria-invalid', 'true');
    input.classList.add('pb-field__input--error');
  }
  function clearFieldError(input) {
    var wrap = fieldWrap(input);
    var err = wrap.querySelector('.pb-field__error');
    if (err && err.parentNode) err.parentNode.removeChild(err);
    input.removeAttribute('aria-invalid');
    input.classList.remove('pb-field__input--error');
  }

  function initReveal() {
    var els = document.querySelectorAll('.pb-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  // ---- Obor podnikání: prodejce a „Jiné" ----
  // Firemní nákup je pro firmy, které zboží samy použijí nebo instalují
  // klientovi. Kdo zboží dál prodává, patří do velkoobchodu — po výběru té
  // možnosti se ukáže nasměrování (odeslání se NEblokuje). U „Jiné" je
  // poznámka povinná. Spouštěcí texty jdou z nastavení sekce, ne z kódu.
  //
  // segment() se posílá do Make jako samostatné pole, aby se scénář mohl
  // rozhodovat podle něj, a ne podle znění možnosti, které se může změnit.
  //
  // Prodejce navíc vybírá typ provozovny (povinné). Make ho předává do žádosti
  // ve velkoobchodu. Mimo prodejce je pole vypnuté, takže se neodesílá.
  function initFieldRules(form) {
    var select = form.querySelector('[data-b2b-field]');
    var resellerNote = form.querySelector('[data-b2b-reseller-note]');
    var typeWrap = form.querySelector('[data-b2b-reseller-type-wrap]');
    var typeSelect = form.querySelector('[data-b2b-reseller-type]');
    var note = form.querySelector('[data-b2b-note]');
    var noteLabel = form.querySelector('[data-b2b-note-label]');

    function norm(v) { return String(v == null ? '' : v).trim().toLowerCase(); }
    var resellerPrefix = select ? norm(select.getAttribute('data-reseller-prefix')) : '';
    var otherOption = select ? norm(select.getAttribute('data-other-option')) : '';

    function segment() {
      if (!select) return '';
      var v = norm(select.value);
      if (!v) return '';
      if (resellerPrefix && v.indexOf(resellerPrefix) === 0) return 'prodejce';
      if (otherOption && v === otherOption) return 'jine';
      return 'firma';
    }

    function noteRequired() { return segment() === 'jine'; }

    function update() {
      var seg = segment();
      var reseller = seg === 'prodejce';
      if (resellerNote) resellerNote.hidden = !reseller;
      if (typeWrap) typeWrap.hidden = !reseller;
      if (typeSelect) {
        typeSelect.disabled = !reseller;
        typeSelect.required = reseller;
        if (reseller) {
          typeSelect.setAttribute('aria-required', 'true');
        } else {
          typeSelect.removeAttribute('aria-required');
          clearFieldError(typeSelect);
        }
      }
      if (note) {
        var req = seg === 'jine';
        note.required = req;
        if (req) {
          note.setAttribute('aria-required', 'true');
        } else {
          note.removeAttribute('aria-required');
          clearFieldError(note);
        }
        if (noteLabel) {
          noteLabel.textContent = req
            ? noteLabel.getAttribute('data-label-required')
            : noteLabel.getAttribute('data-label-optional');
        }
      }
    }

    if (select) select.addEventListener('change', update);
    if (note) note.addEventListener('input', function () { clearFieldError(note); });
    if (typeSelect) typeSelect.addEventListener('change', function () { clearFieldError(typeSelect); });
    update();

    return {
      update: update,
      segment: segment,
      noteRequired: noteRequired,
      note: note,
      typeSelect: typeSelect
    };
  }

  function initForms() {
    var forms = document.querySelectorAll('[data-b2b-form]');

    forms.forEach(function (form) {
      // Theme editor po úpravě sekce volá init znovu. Bez téhle pojistky by se
      // posluchače navázaly podruhé a žádost by odešla dvakrát.
      if (form.getAttribute('data-b2b-ready') === '1') return;
      form.setAttribute('data-b2b-ready', '1');

      var rules = initFieldRules(form);
      var endpoint = form.getAttribute('data-webhook') || '';
      var statusEl = form.querySelector('[data-b2b-status]');
      var fieldsEl = form.querySelector('.pb-form__fields');
      var submitBtn = form.querySelector('[type="submit"]');
      var successMsg = form.getAttribute('data-success') ||
        'Děkujeme! Žádost jsme přijali. Po schválení vám pošleme e-mail s přihlášením.';
      var errorMsg = form.getAttribute('data-error') ||
        'Něco se nepovedlo. Zkuste to prosím znovu, nebo nám napište na info@potzillas.cz.';

      // Anti-bot: čas od načtení formuláře (člověk ho nevyplní pod 2,5 s).
      var startedAt = Date.now();

      var emailInput = form.querySelector('[name="email"]');
      var phoneInput = form.querySelector('[name="phone"]');
      if (emailInput) emailInput.addEventListener('input', function () { clearFieldError(emailInput); });
      if (phoneInput) phoneInput.addEventListener('input', function () { clearFieldError(phoneInput); });

      var termsInput = form.querySelector('[data-b2b-terms-check]');
      if (termsInput) termsInput.addEventListener('change', function () { clearFieldError(termsInput); });

      function setLoading(on) {
        if (!submitBtn) return;
        submitBtn.disabled = on;
        submitBtn.classList.toggle('is-loading', on);
      }

      function showStatus(type, text) {
        if (!statusEl) return;
        statusEl.textContent = text || (type === 'success' ? successMsg : errorMsg);
        statusEl.className = 'pb-form__status pb-form__status--' + type;
        statusEl.hidden = false;
        if (type === 'success' && fieldsEl) {
          fieldsEl.setAttribute('hidden', '');
          statusEl.setAttribute('tabindex', '-1');
          statusEl.focus();
        }
        statusEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        // Honeypot: vyplněné skryté pole = bot -> tiše předstírej úspěch.
        var honeypot = form.querySelector('[name="company_url"]');
        if (honeypot && honeypot.value) {
          showStatus('success');
          return;
        }

        // Časová past: odeslání pod 2,5 s = bot -> tiše předstírej úspěch.
        if (Date.now() - startedAt < 2500) {
          showStatus('success');
          return;
        }

        if (!endpoint) {
          showStatus('error', 'Formulář zatím není propojený — doplň webhook URL v nastavení sekce.');
          return;
        }

        // E-mail ve správném tvaru.
        if (emailInput) {
          clearFieldError(emailInput);
          if (!isValidEmail(emailInput.value)) {
            showFieldError(emailInput, 'Zadejte e-mail ve správném tvaru, např. jmeno@firma.cz.');
            emailInput.focus();
            return;
          }
        }

        // Telefon: normalizace + E.164 validace (když je vyplněný).
        var normalizedPhone = '';
        if (phoneInput) {
          clearFieldError(phoneInput);
          var phoneRes = normalizePhone(phoneInput.value);
          if (!phoneRes.ok) {
            showFieldError(phoneInput, 'Zadejte telefon s mezinárodní předvolbou, např. +420 777 123 456.');
            phoneInput.focus();
            return;
          }
          normalizedPhone = phoneRes.value;
        }

        // Prodejce musí vybrat typ provozovny (jde dál do velkoobchodu).
        if (rules.segment() === 'prodejce' && rules.typeSelect && !rules.typeSelect.value) {
          showFieldError(rules.typeSelect, 'Vyberte prosím typ provozovny.');
          rules.typeSelect.focus();
          return;
        }

        // U „Jiné" je poznámka povinná — vlastní česká hláška před nativní
        // validací (ta by vyskočila v jazyce prohlížeče).
        if (rules.noteRequired() && rules.note && !rules.note.value.trim()) {
          showFieldError(rules.note, 'Napište prosím, čím se zabýváte a k čemu zboží použijete.');
          rules.note.focus();
          return;
        }

        // Souhlas s B2B podmínkami — vlastní česká hláška, ne nativní bublina
        // (ta by vyskočila v jazyce prohlížeče). Kontrolujeme před
        // reportValidity(), aby uživatel dostal naši hlášku, ne systémovou.
        var termsCheck = form.querySelector('[data-b2b-terms-check]');
        if (termsCheck) {
          clearFieldError(termsCheck);
          if (!termsCheck.checked) {
            showFieldError(termsCheck, 'Bez potvrzení podnikatelského režimu a B2B podmínek žádost odeslat nejde.');
            termsCheck.focus();
            return;
          }
        }

        // Ostatní povinná pole (nativní validace).
        if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
          return;
        }

        // Čas souhlasu až v okamžiku odeslání, ISO 8601 UTC.
        var termsTime = form.querySelector('[data-b2b-terms-time]');
        if (termsTime) termsTime.value = new Date().toISOString();

        // Zrcadlo pro původní pole `consent` (Make ho mapuje) — vyplní se až
        // tady, tedy jen když je jediný checkbox skutečně zaškrtnutý.
        var termsMirror = form.querySelector('[data-b2b-terms-mirror]');
        if (termsMirror) termsMirror.value = termsCheck && termsCheck.checked ? 'ano' : '';

        setLoading(true);

        var data = new FormData(form);
        data.delete('company_url'); // honeypot neposíláme
        if (phoneInput) data.set('phone', normalizedPhone); // normalizovaný telefon do payloadu
        data.append('source', 'potzillas-b2b-web');
        data.append('submitted_at', new Date().toISOString());
        // firma | prodejce | jine — Make podle toho pozná prodejce bez ohledu
        // na to, jak je možnost zrovna pojmenovaná.
        data.append('segment', rules.segment());

        fetch(endpoint, { method: 'POST', body: data })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            form.reset();
            rules.update();
            showStatus('success');
          })
          .catch(function () {
            setLoading(false);
            showStatus('error');
          });
      });
    });
  }

  function init() {
    initReveal();
    initForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor — re-init po vlozeni/uprave sekce.
  document.addEventListener('shopify:section:load', init);
})();
